<template>
    <div class="inputfield">
        <div class="inputfield-container">
            <div class="inputfield-panel">
                <div class="inputfield-panel__item" @click="smiles = !smiles" >
                    <img src="@/assets/images/icons/smile.svg" width="24px"/>
                    <div class="emoji-picker" v-show="smiles" @click.stop>
                        <VEmojiPicker
                            :emojiSize="24"
                            :emojisByRow="7"
                            :continuousList="true"
                            @select="addSmile"/>
                    </div>
                </div>
            </div>
            <textarea
                name="inputfield"
                v-model="value"
                :placeholder="placeholder"
                cols="10"
                :rows="rows">
            </textarea>
        </div>
        <div class="button" @click="sendData()">Отправить</div>
    </div>
</template>
<script>
import { VEmojiPicker } from 'v-emoji-picker';
export default {
    name: 'InputField',
    props: {
        rows: {
            type: Number,
            required: false,
            defalut: 3
        },
        placeholder: {
            type: String,
        }
    },
    data () {
        return {
            value: '',
            smiles: false,
        }
    },
    components: {
        VEmojiPicker
    },
    methods: {
        addSmile(smile) {
            this.value += smile.data
        },
        sendData() {
            this.$emit('sendData', this.value.replace(/\n/, '<br>'))
            this.value = ''
        }
    }
}
</script>

<style lang="stylus" scoped>
.inputfield
    width 100%
    display flex
    flex-direction column
    align-items flex-end
    textarea
        width 100%
        padding 26px
        background-color: #f8f8f8
        border none
        border-radius: 15px
        font-size: 14px
        font-weight: 500
        line-height: 24px
        position relative
    &-container
        width 100%
        position relative
    &-panel
        z-index 2
        right 20px
        top 20px
        position absolute
    .button
        margin-top 10px
    
    .emoji-picker
        position absolute
        right 0px
</style>